import React from "react";
import LeftServiceSubCardSection1 from "./LeftServiceSubCardSection1";

const LeftServiceCardSection1 = () => {
  return (
    <div className="mt-16">
      <h1 className="text-3xl font-medium"> School Discipline</h1>
      <hr className="mt-4 border-black" />
      <ul className=" mt-8 space-y-3 lg:space-x-7 text-xl text-gray-800">
        <LeftServiceSubCardSection1
          quote="Discipline is the continual exercise of the will, enlightened by the intellect so that it may act easily and habitually, according to right order and help the child to attain self mastery.
                        Discipline is a Basic Foundation for a Virtuous Life.
                         Hence the School expects every child to contribute to the discipline of the school"
        />
        <br />
        <hr />
        <LeftServiceSubCardSection1
          quote="Punctuality:
                Punctuality is the politeness of kings. It is also the duty of gentlemen and the necessity of persons of business"
        />
        <br />
        <hr />
        <LeftServiceSubCardSection1 quote=" Silence: There is a time for speaking and a time for being still: Special care must be taken by teachers and pupils to preserve an ATMOSPHERE OF SILENCE AND SERIOUS WORK during class hours." />
        {/* <LeftServiceSubCardSection1 />
        <LeftServiceSubCardSection1 />
        <LeftServiceSubCardSection1 /> */}
      </ul>
    </div>
  );
};

export default LeftServiceCardSection1;
